import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3" }

import { InputRow, Combobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { computed, ref } from 'vue';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData, SelectOption, Company } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeePersonalForm',
  props: {
    form: {},
    company: {},
    productionUnitsData: {},
    departmentsData: {},
    companiesData: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const isClient = computed(() => page.props.auth.user.is_client);

    const props = __props;

    const productionUnitOptions = computed(() => {
        const types = props.productionUnitsData ?? [];

        return Object.entries(types).map(([key, label]) => ({
            value: key,
            label: label as string,
        }));
    });

    const departmentsOptions = computed(() => {
        const types = props.departmentsData ?? [];

        return Object.entries(types).map(([key, label]) => ({
            value: key,
            label: label as string,
        }));
    });

    const companiesOptions = computed(() => {
        const types = props.companiesData ?? [];

        return Object.entries(types).map(([key, label]) => ({
            value: Number(key),
            label: label as string,
        }));
    });

    const applyMask = (e: Event) => {
        const input = e.target as HTMLInputElement;
        let val = input.value.replace(/\D/g, ''); // remove non-digits
        if (val.length > 6) {
            val = val.slice(0, 6) + '-' + val.slice(6, 10);
        }
        props.form.customer_employees.cpr = val;
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "first_name",
      label: "employee.personal.first_name",
      "error-key": "customer_employees.first_name"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "first_name",
          modelValue: _ctx.form.customer_employees.first_name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.customer_employees.first_name) = $event)),
          placeholder: _ctx.$t('employee.personal.first_name')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "last_name",
      label: "employee.personal.last_name",
      "error-key": "customer_employees.last_name"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "last_name",
          modelValue: _ctx.form.customer_employees.last_name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.customer_employees.last_name) = $event)),
          placeholder: _ctx.$t('employee.personal.last_name')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "cpr",
      label: "employee.personal.cpr",
      "error-key": "customer_employees.cpr"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "cpr",
          modelValue: _ctx.form.customer_employees.cpr,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.customer_employees.cpr) = $event)),
          placeholder: "ddmmyy-xxxx",
          onInput: applyMask
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "email",
      label: "employee.personal.email",
      "error-key": "customer_employees.email"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "email",
          modelValue: _ctx.form.customer_employees.email,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.customer_employees.email) = $event)),
          placeholder: _ctx.$t('employee.personal.email')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    (!isClient.value)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 0,
          form: _ctx.form,
          name: "company_id",
          label: "employee.personal.company_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Combobox), {
              modelValue: _ctx.form.customer_employees.company_id,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.customer_employees.company_id) = $event)),
              options: companiesOptions.value,
              placeholder: _ctx.$t('employee.personal.company_id'),
              "show-remove-button": false
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "phone_cell",
      label: "employee.personal.phone_cell"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "phone_cell",
          modelValue: _ctx.form.customer_employees.phone_cell,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.customer_employees.phone_cell) = $event)),
          placeholder: _ctx.$t('employee.personal.phone_cell')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    (departmentsOptions.value.length > 0)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 1,
          form: _ctx.form,
          name: "department",
          label: "employee.personal.department"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Combobox), {
              modelValue: _ctx.form.customer_employees.department,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.customer_employees.department) = $event)),
              options: departmentsOptions.value,
              placeholder: _ctx.$t('employee.personal.department')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]),
          _: 1
        }, 8, ["form"]))
      : (_openBlock(), _createBlock(_unref(InputRow), {
          key: 2,
          form: _ctx.form,
          name: "department",
          label: "employee.personal.department"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Input), {
              id: "department",
              modelValue: _ctx.form.customer_employees.department,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.customer_employees.department) = $event)),
              placeholder: _ctx.$t('employee.personal.department')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["form"])),
    (_ctx.company.employees_optional?.production_unit)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 3,
          form: _ctx.form,
          name: "production_unit",
          label: "employee.optional.production_unit"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Combobox), {
              modelValue: _ctx.form.optional.production_unit,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.optional.production_unit) = $event)),
              options: productionUnitOptions.value,
              placeholder: _ctx.$t('employee.optional.production_unit')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true)
  ]))
}
}

})